module.exports = __webpack_public_path__ + "static/screenshot3-a5878d56d69a007b3b2e040b8cd326c2.png";